import { postHttpClientRequest } from '@vz/react-util/dist/cjs';
import { apiUrls,apiHostUrl } from '../../shared/utils/globalConfig';

export const updateCart = (payload) => {
    var axConfig = {
        headers: {flowName: "Auth-INTL-NSA"}
      };
    return postHttpClientRequest(
        apiHostUrl + apiUrls?.itpNsaCartUpdateUrl,
        payload,axConfig)

}




/* import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiUrls,apiHostUrl } from '../../shared/utils/globalConfig'; */



/* export const updatePlansApi = createApi({
    reducerPath: 'updatePlans',
    baseQuery: fetchBaseQuery({
        baseUrl: apiHostUrl,
        
    }),
    endpoints: (builder) => ({
        updatedPlansByName: builder.query({
            query: (payload) => ({
                url: apiUrls?.itpNsaCartUpdateUrl,
                method: 'POST',
                body: payload
            })
        }),
    }),

})

export const { useLazyUpdatedPlansByNameQuery } = updatePlansApi; */